import Immutable from 'seamless-immutable'
import { handleActions } from 'redux-actions'
import { appTypes } from '../actions/types'

const initialState = Immutable({
  helloRedux: 'hello',
})

export default handleActions({
  [appTypes.helloRedux]: (state, { value }) => state.set('helloRedux', value),
}, initialState)
